var _path, _path2, _path3, _ellipse, _path4, _rect, _path5, _path6, _ellipse2, _ellipse3, _ellipse4, _path7, _path8, _ellipse5, _path9, _ellipse6, _ellipse7, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _ellipse8, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _circle, _circle2, _path37, _path38, _ellipse9, _path39, _path40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlower5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 406,
    viewBox: "0 0 397 406",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.981 2.64086L317.945 16.2489L317.799 16.6442L317.404 16.7904L303.796 21.8259L317.404 26.8613L317.799 27.0076L317.945 27.4028L322.981 41.0109L328.016 27.4028L328.162 27.0076L328.558 26.8613L342.166 21.8259L328.558 16.7904L328.162 16.6442L328.016 16.2489L322.981 2.64086Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 1.83295
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3009 292.487L53.3141 300.558L53.1678 300.954L52.7726 301.1L44.7007 304.087L52.7726 307.074L53.1678 307.22L53.3141 307.615L56.3009 315.687L59.2878 307.615L59.434 307.22L59.8293 307.074L67.9011 304.087L59.8293 301.1L59.434 300.954L59.2878 300.558L56.3009 292.487Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 1.83295
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.849 36.7659L377.346 46.2319L377.2 46.6271L376.805 46.7734L367.339 50.2761L376.805 53.7789L377.2 53.9251L377.346 54.3204L380.849 63.7864L384.352 54.3204L384.498 53.9251L384.893 53.7789L394.359 50.2761L384.893 46.7734L384.498 46.6271L384.352 46.2319L380.849 36.7659Z",
    fill: "#CCFF90",
    stroke: "black",
    strokeWidth: 1.83295
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 5.34039,
    ry: 8.30728,
    transform: "matrix(-1 0 0 1 274.071 351.557)",
    fill: "#ECEFF1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M241.434 371.736C247.368 385.977 259.235 407.338 281.784 397.251C300.772 387.163 316.801 376.055 317.98 361.648C311.453 340.88 281.191 359.865 270.381 343.717C263.39 342.064 237.825 356.425 241.434 371.736Z",
    fill: "#ECEFF1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.751,
    height: 105.621,
    transform: "matrix(-0.951384 0.308006 0.308006 0.951384 246.879 256.617)",
    fill: "#ECEFF1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M279.41 200.842C279.41 210.018 326.88 225.764 316.199 217.456C323.319 232.291 352.988 210.018 352.988 200.842C348.835 159.896 339.341 190.751 316.199 184.227C295.881 184.227 279.41 191.666 279.41 200.842Z",
    fill: "#ECEFF1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M337.764 177.385C332.44 190.432 332.829 202.929 338.632 205.296C344.435 207.664 353.455 199.006 358.778 185.959C364.102 172.911 363.713 160.415 357.91 158.047C352.107 155.68 338.632 153.367 337.764 177.385Z",
    fill: "#ECEFF1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.2742,
    ry: 23.7351,
    transform: "matrix(-1 0 0 1 358.329 101.151)",
    fill: "#ECEFF1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.8675,
    ry: 23.7351,
    transform: "matrix(-1 0 0 1 332.815 104.712)",
    fill: "#ECEFF1"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.8675,
    ry: 23.7351,
    transform: "matrix(-0.247214 0.968961 0.968961 0.247214 342.484 136.32)",
    fill: "#ECEFF1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M355.362 129.634C355.362 140.121 361.738 148.622 369.603 148.622C377.469 148.622 385.031 140.121 385.031 129.634C385.031 119.147 380.435 112.426 372.57 112.426C364.705 112.426 355.362 119.147 355.362 129.634Z",
    fill: "#ECEFF1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M338.784 135.568C338.784 171.633 344.886 174.185 352.414 174.185C359.941 174.185 366.043 156.895 366.043 135.568C366.043 114.241 359.941 96.9512 352.414 96.9512C344.886 96.9512 338.784 114.241 338.784 135.568Z",
    fill: "#ECEFF1"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.56026,
    ry: 13.6477,
    transform: "matrix(-0.894941 -0.446184 -0.446184 0.894941 315.231 147.719)",
    fill: "#CCFF90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.968 144.792C233.958 153.42 258.004 167.454 284.157 179.608C307.299 194.442 324.507 196.817 331.034 186.729C335.044 178.102 314.419 151.175 292.581 151.177C266.428 139.024 241.977 136.165 237.968 144.792Z",
    fill: "#CCFF90"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.5814,
    ry: 5.93377,
    transform: "matrix(-0.945533 -0.325527 -0.325527 0.945533 311.182 224.228)",
    fill: "#CCFF90"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 19.5814,
    ry: 5.93377,
    transform: "matrix(-0.945533 -0.325527 -0.325527 0.945533 289.82 217.105)",
    fill: "#CCFF90"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M233.128 234.789C233.128 249.864 253.85 262.085 279.412 262.085C306.707 267.425 329.255 241.317 331.629 225.295C331.629 210.221 300.773 245.47 279.412 207.494C253.85 207.494 233.128 219.715 233.128 234.789Z",
    fill: "#CCFF90"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M207.613 266.241L197.525 265.055C196.842 279.963 195.026 286.652 192.185 301.844C202.722 304.793 208.216 304.78 217.7 303.624L207.613 266.241Z",
    fill: "#CCFF90"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.662 256.493C249.413 269.824 252.488 281.541 257 281.541C261.513 281.541 265.171 270.383 265.171 256.619C265.171 242.855 261.513 231.697 257 231.697C252.488 231.697 242.409 245.481 247.662 256.493Z",
    fill: "#CCFF90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M123.947 98.3147C132.848 141.631 141.32 154.092 180.318 154.092C219.316 154.092 238.165 129.04 238.165 95.9412C238.165 62.8422 228.078 33.6367 185.948 34.824C146.192 33.0434 113.859 69.8326 123.947 98.3147Z",
    fill: "#CCFF90"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4222 152.902C72.3229 196.219 107.496 190.879 146.494 190.879C185.492 190.879 172.604 181.848 172.604 148.749C172.604 115.65 159.977 92.378 120.979 92.378C78.8489 85.2597 60.4553 117.3 63.4222 152.902Z",
    fill: "#CCFF90"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.11 130.357C163.11 169.355 199.772 200.969 244.996 200.969C287.126 196.222 310.268 173.08 322.135 128.577C333.106 111.964 302.844 53.2185 251.813 62.1195C208.497 75.1738 163.11 91.3591 163.11 130.357Z",
    fill: "#CCFF90"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4442 211.056C69.3568 247.252 116.827 297.096 154.803 270.394C196.933 265.647 221.261 255.56 233.129 211.056C233.129 172.058 201.214 142.225 155.99 142.225C112.673 155.279 88.3449 169.52 79.4442 211.056Z",
    fill: "#CCFF90"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 87.8198,
    ry: 86.0397,
    transform: "matrix(-1 0 0 1 208.206 180.796)",
    fill: "#FF80AB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246.765 258.549C246.927 257.596 255.995 286.17 256.032 286.339C256.388 287.957 256.901 289.533 257.408 291.119C258.64 294.962 260.139 298.691 261.37 302.534C265.299 314.808 269.644 326.684 274.462 338.646C276.049 342.588 277.951 348.407 282.306 350.23C294.496 355.334 317.851 343.524 317.38 365.063C316.837 380.805 268.746 411.129 255.488 395.307C237.086 374.583 215.168 291.709 207.019 265.95",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.892 266.447C196.892 305.648 180.305 331.247 179.126 332.796C173.257 340.522 168.686 343.973 159.597 347.268C155.153 348.877 147.703 348.444 144.343 352.196C142.257 354.527 141.912 358.908 142.377 361.854C144.063 372.522 150.987 383.096 141.18 391.977C138.954 393.993 135.981 395.619 132.874 395.466C130.129 395.33 127.599 394.757 125.025 393.756C121.471 392.372 118.214 390.775 115.241 388.377C102.501 378.087 82.4401 346.283 93.6836 329.782C100.238 320.163 123.698 320.082 134.023 313.668C138.669 310.781 142.127 306.668 144.073 301.667C144.65 300.19 145.212 298.738 145.486 297.176C145.572 296.692 148.606 292.142 157.175 251.869",
    fill: "#ECEFF1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.892 266.447C196.892 305.648 180.305 331.247 179.126 332.796C173.257 340.522 168.686 343.973 159.597 347.268C155.153 348.877 147.703 348.444 144.343 352.196C142.257 354.527 141.912 358.908 142.377 361.854C144.063 372.522 150.987 383.096 141.18 391.977C138.954 393.993 135.981 395.619 132.874 395.466C130.129 395.33 127.599 394.757 125.025 393.756C121.471 392.372 118.214 390.775 115.241 388.377C102.501 378.087 82.4401 346.283 93.6836 329.782C100.238 320.163 123.698 320.082 134.023 313.668C138.669 310.781 142.127 306.668 144.073 301.667C144.65 300.19 145.212 298.738 145.486 297.176C145.572 296.692 148.606 292.142 157.175 251.869",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M295.164 183.562C328.104 209.971 343.014 178.284 340.021 147.564",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.616 189.873C120.255 186.685 120.075 183.479 120.077 180.27C120.077 132.993 159.329 94.6797 207.744 94.6797C256.159 94.6797 295.411 132.993 295.411 180.27C295.411 227.547 256.159 265.861 207.744 265.861C191.246 265.951 175.057 261.395 161.028 252.712C147.206 244.157 136.788 232.735 129.523 218.239",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M241.428 174.225C242.916 174.225 244.123 173.018 244.123 171.529C244.123 170.041 242.916 168.834 241.428 168.834C239.939 168.834 238.732 170.041 238.732 171.529C238.732 173.018 239.939 174.225 241.428 174.225Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M215.67 176.061C217.158 176.061 218.365 174.854 218.365 173.365C218.365 171.877 217.158 170.67 215.67 170.67C214.181 170.67 212.975 171.877 212.975 173.365C212.975 174.854 214.181 176.061 215.67 176.061Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M238.192 184.484C237.713 200.616 221.721 196.803 221.142 185.383",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M330.74 124.717C334.71 125.064 338.629 125.857 342.422 127.08C349.019 128.97 352.686 133.922 353.253 137.59C353.681 139.386 353.458 141.275 352.623 142.923C351.789 144.57 350.399 145.868 348.698 146.587C343.5 148.856 327.489 144.508 324.597 142.07C320.098 138.289 316.677 123.772 332.158 124.755",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M290.78 208.572C293.918 216.378 321.214 222.181 323.198 221.803C331.194 222.408 359.548 219.611 364.784 149.123C364.784 149.123 380.228 152.204 384.424 130.844C388.621 109.484 369.661 112.792 369.661 112.792C369.661 112.792 372.138 77.141 359.17 77.0276C346.203 76.9142 347.073 111.185 347.073 111.185C347.073 111.185 344.483 76.8386 331.138 79.9764C317.792 83.1143 322.915 112.413 322.915 112.413L325.731 124.946",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.704 111.892C372.15 112.476 372.038 113.311 371.454 113.757C367.462 116.806 364.739 121.68 362.91 126.533C361.091 131.361 360.215 136.01 359.825 138.448L359.823 138.459L359.823 138.459C359.55 140.07 359.729 141.725 360.342 143.24C360.969 144.667 362.012 145.873 363.335 146.699C364.663 147.529 366.21 147.937 367.774 147.872C368.508 147.841 369.128 148.411 369.159 149.145C369.19 149.879 368.62 150.499 367.886 150.53C365.786 150.618 363.708 150.069 361.925 148.956C360.143 147.842 358.739 146.215 357.897 144.289L357.89 144.274L357.884 144.258C357.081 142.283 356.843 140.123 357.198 138.021C357.602 135.504 358.513 130.659 360.421 125.595C362.321 120.552 365.268 115.134 369.839 111.642C370.423 111.196 371.258 111.308 371.704 111.892Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2717 186.406C87.7054 185.814 88.5371 185.685 89.1294 186.119C89.7216 186.553 89.8501 187.385 89.4163 187.977L87.2717 186.406ZM152.325 275.19C139.181 280.387 124.205 279.184 111.292 273.446C98.3804 267.708 87.4082 257.381 82.3382 244.163L84.8202 243.211C89.5978 255.667 99.9964 265.517 112.372 271.017C124.748 276.516 138.976 277.609 151.347 272.718L152.325 275.19ZM77.5606 217.724C77.6061 217.543 77.6428 217.18 77.6661 216.525C77.6891 215.878 77.6955 215.153 77.7224 214.192C77.7746 212.332 77.8987 209.919 78.3606 207.099C79.2864 201.446 81.5615 194.203 87.2717 186.406L89.4163 187.977C83.9873 195.389 81.8521 202.228 80.984 207.528C80.549 210.184 80.4303 212.465 80.3797 214.267C80.3553 215.137 80.3453 215.984 80.3227 216.62C80.3004 217.248 80.2622 217.879 80.1394 218.37L77.5606 217.724Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M219 303.714C210.916 305.268 201.006 304.999 193.508 301.357",
    stroke: "black",
    strokeWidth: 2.65833,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M332.534 220.811C325.679 253.586 301.473 269.223 265.262 260.654C265.471 269.111 261.609 277.514 255.082 282.854",
    stroke: "black",
    strokeWidth: 2.65833,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3433 187.191C40.5733 170.054 61.1393 77.4552 122.716 92.7906C112.896 35.2261 219.478 9.05935 235.791 68.0526C281.783 44.1173 322.881 85.193 324.867 125.439M323.14 141.077C321.394 147.202 318.328 153.066 313.748 158.403C323.572 166.522 328.91 175.442 331.628 185.411",
    stroke: "black",
    strokeWidth: 2.65833,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M107.912 245.678L128.202 232.215",
    stroke: "black",
    strokeWidth: 2.65833,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M294.922 221.717L315.014 232.038",
    stroke: "black",
    strokeWidth: 2.32012,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M116.826 142.226L94.2778 131.545",
    stroke: "black",
    strokeWidth: 2.65833,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.039 85.4839L173.073 61.5259",
    stroke: "black",
    strokeWidth: 2.65833,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M274.771 108.459L290.092 88.7666",
    stroke: "black",
    strokeWidth: 2.65833,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 5.93377,
    transform: "matrix(-1 0 0 1 260.423 179.012)",
    fill: "#CCFF90"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 5.93377,
    transform: "matrix(-1 0 0 1 196.338 183.762)",
    fill: "#CCFF90"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M247.368 257.816C233.251 263.03 223.817 264.929 208.205 265.53L214.732 287.485C215.501 275.557 229.504 265.396 247.368 257.816Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M198.117 265.795C183.066 264.309 172.01 257.438 158.361 251.291L151.24 280.366C155.828 269.615 183.293 265.677 198.117 265.795Z",
    fill: "black"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.49403,
    ry: 16.0212,
    transform: "matrix(-1 0 0 1 135.814 192.66)",
    fill: "#ECEFF1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M134.154 176.672C131.24 180.183 128.146 183.542 124.886 186.735C106.267 205.27 62.3352 240.625 18.1938 215.019C13.2149 212.153 6.60412 214.893 3.80083 221.295C-0.383182 230.709 0.537301 244.118 30.9969 252.131C31.3108 252.241 31.5705 252.467 31.7224 252.763C31.8742 253.059 31.9066 253.402 31.8128 253.721C30.8505 258.888 28.8003 276.733 52.0425 257.507C52.7986 256.876 53.6539 256.374 54.5738 256.022C63.0883 252.863 110.514 234.767 133.108 214.935C135.493 212.882 137.698 210.628 139.698 208.199",
    fill: "#ECEFF1",
    stroke: "black",
    strokeWidth: 2.66056,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M293.057 202.027L290.683 209.148C298.884 216.052 309.877 219.94 320.945 220.422C301.957 213.895 294.837 205.588 293.057 202.027Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower5);
export default __webpack_public_path__ + "static/media/Flower5.d6eca509802e186dabecef7ef3f3a2f9.svg";
export { ForwardRef as ReactComponent };